import { render } from "./AuNoData.vue?vue&type=template&id=3cd6116d&scoped=true"
import script from "./AuNoData.vue?vue&type=script&lang=js"
export * from "./AuNoData.vue?vue&type=script&lang=js"

import "./AuNoData.vue?vue&type=style&index=0&id=3cd6116d&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cd6116d"]])

export default __exports__